// extracted by mini-css-extract-plugin
export default {"search":"Search-module--search--aa30e"};